<template>
  <nav id="main-nav">
    <v-navigation-drawer
        v-model="drawer"
        app
        permanent
        mini-variant-width="100"
        expand-on-hover
        dark
        class="secondary"
    >
      <v-list nav dense color="rgba(245,245,245,1)">
        <v-list-item class="px-2">
          <div>
            <v-img
                class="logo-firma"
                id="nav_bar__logo__image"
                src="../assets/LogoCONTPAQiFirma_Positivo2.png"
            ></v-img>
          </div>
          <v-list-item-title>
            <version-tag class="text-center ml-2"></version-tag>
          </v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>

      <v-list nav dense>
        <v-list-item
            v-for="link in links"
            :id="link.id"
            :key="link.text"
            router
            :to="link.route"
            active-class="border"
        >
          <v-list-item-action class="text-center">
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ link.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import { appThemeData } from '@/store/helpers'
import {
  mdiFormatListBulletedType,
  mdiFileDocumentOutline,
  mdiFolderOutline,
  mdiHomeOutline
} from '@mdi/js'

export default {
  name: 'NavBar',
  data() {
    return {
      drawer: true,
      links: [
        { 
          icon: mdiHomeOutline, 
          text: 'Dashboard', 
          route: '/dashboard', 
          id: 'nav_bar__dashboard__menu0'
        },
        {
          icon: mdiFileDocumentOutline,
          text: 'Documentos',
          route: '/documentos',
          id: 'nav_bar__documentos__menu1'
        },
        {
          icon: mdiFormatListBulletedType,
          text: 'Tipos de Documento',
          route: '/tipoDocumento',
          id: 'nav_bar__tipos_documento__menu2'
        },
        { 
          icon: mdiFolderOutline, 
          text: 'Carpetas', 
          route: '/carpetas', 
          id: 'nav_bar__carpetas__menu3' 
        }
      ]
    }
  },
  computed: {
    ...appThemeData
  },
  mounted(){
    if (document.getElementById('idiadvize')) { return }
    let script = document.createElement('script')
    let t = document.getElementsByTagName("script")[0]
    script.setAttribute('id', 'idiadvize')
    if (typeof(iAdvize) !== "undefined"){
      script.textContent = "iAdvize.navigate('"+ window.location.pathname + "')"
    }
    t.parentNode.insertBefore(script,t)
  },
  beforeDestroy(){
    let el = document.getElementById('idiadvize')
    if (el) { el.remove() }
  }
}
</script>

<style lang="scss" scoped>
.logo-firma {
  max-width: 105px;
}
</style>
